import React from "react";

const FilterTabs = ({ tabs, active, onChange }) => (
  <div className="flex items-center gap-1 flex-wrap">
    {tabs.map((tab) => (
      <button
        key={tab}
        type="button"
        onClick={() => onChange(tab)}
        className={`px-3.5 py-1.5 rounded-pill text-sm font-medium border transition-colors ${
          active === tab
            ? "bg-brand text-white border-brand"
            : "bg-white text-textMuted border-inputBorder hover:text-textPrimary hover:border-gray-400"
        }`}
      >
        {tab}
      </button>
    ))}
  </div>
);

export default FilterTabs;
